import script from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=12cd53f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12cd53f0"]])

export default __exports__